module.exports = __webpack_public_path__ + "static/img/code.ddeb3f7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/index/pic/code.jpg
// module id = U68G
// module chunks = 11